import { Component } from 'react'
import styled from '@emotion/styled'
import { Box, EmulationHistory } from 'stylewhere/components'
import { Emulation } from 'core/shared'

interface Props {
  title: string
  list: Emulation[]
  onSubmit: (value: string, confirm?: boolean) => void
  onFavorite: (name: string, key: number) => void
  onDelete: (name: string, key: number) => void
  mb?: number
}

export class EmulationBox extends Component<Props> {
  render() {
    const { title, list, onSubmit, onFavorite, onDelete, mb } = this.props
    return (
      <Box
        style={{ border: '2px solid #D2D2D2' }}
        borderRadius={10}
        height={list.length > 0 ? 'calc(50% - 5px)' : '100%'}
        p={'10px 10px'}
        mb={mb}
      >
        <SavedListTitle>{title}</SavedListTitle>
        <div style={{ overflowY: 'scroll', width: '100%', height: '100%' }}>
          {list.map((elem, index) => (
            <EmulationHistory
              emulation={elem}
              key={'emulation-' + index}
              onSubmit={onSubmit}
              onDelete={onDelete}
              onFavorite={onFavorite}
            />
          ))}
        </div>
      </Box>
    )
  }
}

const SavedListTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  text-align: left;
  margin-bottom: 10px;
`
